<nb-card class="prereq-decide">
  <nb-card-header>
    <h4><nb-icon icon="link-2-outline"></nb-icon>Kursverknüpfung bestätigen</h4>
  </nb-card-header>

  <nb-card-body>
    <p *ngIf="loading" class="prereq-decide__muted">Wird geladen …</p>

    <p *ngIf="!loading && notFound" class="prereq-decide__muted">
      Diese Verknüpfung gibt es nicht mehr. Vermutlich wurde sie inzwischen
      entschieden oder gelöscht.
    </p>

    <ng-container *ngIf="!loading && link">
      <!-- Der Satz, der vorher nirgends stand: was genau bestätigt wird. -->
      <p class="prereq-decide__what">
        Der Agent von <strong>{{ link.target_course_name || 'diesem Kurs' }}</strong>
        darf die Inhalte von
        <strong>{{ link.source_course_name || 'dem verknüpften Kurs' }}</strong>
        lesen — nicht nur nennen.
      </p>
      <p class="prereq-decide__muted">
        Deine Bestätigung genügt — es müssen nicht alle Verantwortlichen
        zustimmen. Geschlossen wird die Anfrage erst, wenn niemand mehr
        zustimmen könnte.
      </p>

      <div class="prereq-decide__status">
        <span class="prereq-decide__chip" [class.is-live]="link.status === 'active'">
          {{ statusLabel }}
        </span>
      </div>

      <ul class="prereq-decide__approvals">
        <li *ngFor="let a of link.approvals" [ngClass]="'is-' + a.state">
          <nb-icon
            [icon]="a.state === 'granted' ? 'checkmark-circle-2-outline'
                   : a.state === 'rejected' ? 'close-circle-outline' : 'clock-outline'"
          ></nb-icon>
          <span>{{ a.side === 'target' ? 'Lesender Kurs' : 'Verknüpfter Kurs' }}</span>
          <span class="prereq-decide__muted">
            — {{ a.state === 'granted' ? 'bestätigt' : a.state === 'rejected' ? 'abgelehnt' : 'ausstehend' }}
            <ng-container *ngIf="a.user_name">· {{ a.user_name }}</ng-container>
          </span>
          <span class="prereq-decide__when" *ngIf="a.decided_at">{{ a.decided_at | date : 'short' }}</span>
        </li>
      </ul>

      <p class="prereq-decide__muted" *ngIf="!canDecide && link.my_state === 'granted'">
        Ihre Zustimmung liegt bereits vor.
      </p>
      <p class="prereq-decide__muted" *ngIf="canOverride">
        Als Managerin oder Admin kannst du für alle entscheiden. Im Protokoll
        steht dann, dass die Verwaltung entschieden hat — nicht die
        verantwortliche Person.
      </p>
      <p class="prereq-decide__muted" *ngIf="!canDecide && !link.my_state">
        Sie sind für keinen der beiden Kurse verantwortlich und können hier
        nicht entscheiden.
      </p>
    </ng-container>
  </nb-card-body>

  <nb-card-footer>
    <button type="button" nbButton status="basic" outline (click)="dialogRef.close(false)">
      Schließen
    </button>
    <button
      *ngIf="canDecide"
      type="button" nbButton status="basic" class="btn-caution"
      [disabled]="busy" (click)="decide(false)"
    >Ablehnen</button>
    <button
      *ngIf="canDecide"
      type="button" nbButton status="primary"
      [disabled]="busy" (click)="decide(true)"
    >{{ busy ? 'Läuft …' : 'Bestätigen' }}</button>
    <button
      *ngIf="canOverride"
      type="button" nbButton status="primary"
      [disabled]="busy" (click)="decide(true, true)"
      nbTooltip="Beantwortet alle noch offenen Zustimmungen. Wird als Entscheidung der Verwaltung protokolliert."
    >{{ busy ? 'Läuft …' : 'Für alle bestätigen' }}</button>
  </nb-card-footer>
</nb-card>
